var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M7.22 16.779a.75.75 0 0 0 1.06 0L17.5 7.561v7.627a.75.75 0 0 0 1.5 0V5.75a.75.75 0 0 0-.75-.75H8.81a.75.75 0 1 0 0 1.5h7.627L7.22 15.718a.75.75 0 0 0 0 1.061",
    clipRule: "evenodd"
  })));
};
export default SvgLink;